import {WidgetFullEditorPortal} from "../common/WidgetFullEditorPortal"
import {TextWidgetData} from "@dv5/domain"
import {FC} from "react"
import {useWidgetEditState} from "../../hooks/useWidgetEditState"
import {useWidgetEditor} from "../../hooks/useWidgetEditor"
import {EditorWidgetProps} from "../../model/WidgetProps"
import {widgetService} from "../../services/widgetService"
import {WidgetPlainText} from "../common/WidgetPlainText"
import {WidgetFrame} from "../common/WidgetFrame"
import {TextWidgetFullEditor} from "./TextWidgetFullEditor"
import {TextWidgetInlineEditor} from "./TextWidgetInlineEditor"
import {TextWidgetToolbar} from "./TextWidgetToolbar"
import './TextWidget.less'

type Props = EditorWidgetProps

export const TextWidget: FC<Props> = ({
                                          canvasId,
                                          widget,
                                          selected,
                                          settings,
                                          editingWidgetId,
                                          onStartDrag,
                                          onStartResize,
                                          onContextMenu,
                                          dragState,
                                          onStartLinkCreation,
                                          onCompleteLinkCreation,
                                          onNavigate,
                                          onDeleteDataLink,
                                          onStopEditing,
                                      }) => {
    const data = widget.data as TextWidgetData
    const {isFullEditor, setIsFullEditor, stopEditing} = useWidgetEditState(onStopEditing, settings.readOnly)

    const {
        containerRef,
        resizeCursor,
        handlers,
        renderResizeHandles,
        renderLinkDots,
    } = useWidgetEditor({
        widget,
        selected,
        editingWidgetId,
        dragState,
        onStartDrag,
        onStartResize,
        onContextMenu,
        onStartLinkCreation,
        onCompleteLinkCreation,
        onNavigate,
        onDeleteDataLink,
    })

    if (editingWidgetId && editingWidgetId === widget.id) {
        const toolbarStyles = widgetService.getToolbarStyle(widget)
        return (
            <div className='text-widget-edit-container' ref={containerRef} onContextMenu={handlers.onContextMenu}>
                {!isFullEditor && (
                    <TextWidgetToolbar
                        canvasId={canvasId}
                        widgetId={widget.id}
                        data={data}
                        toolbarStyles={toolbarStyles}
                        onExpandToFull={() => setIsFullEditor(true)}
                    />
                )}
                <div className={widgetService.getWidgetClasses(widget, 'textWidget', selected, editingWidgetId, widget.commentsCount > 0)}
                     style={widgetService.getWidgetStyle(widget)}>
                    <TextWidgetInlineEditor
                        widgetId={widget.id}
                        text={data.text}
                        canvasId={canvasId}
                        data={data}
                        containerRef={containerRef}
                        contentStyle={widgetService.getWidgetContentStyle(widget)}
                    />
                </div>
                {isFullEditor && (
                    <WidgetFullEditorPortal>
                        <TextWidgetFullEditor
                            canvasId={canvasId}
                            widgetId={widget.id}
                            data={data}
                            toolbarStyles={toolbarStyles}
                            onClose={stopEditing}
                        />
                    </WidgetFullEditorPortal>
                )}
            </div>
        )
    }

    return (
        <WidgetFrame
            baseClass='textWidget'
            canvasId={canvasId}
            widget={widget}
            settings={settings}
            selected={selected}
            editingWidgetId={editingWidgetId}
            resizeCursor={resizeCursor}
            handlers={handlers}
            containerRef={containerRef}
            renderResizeHandles={renderResizeHandles}
            renderLinkDots={renderLinkDots}
            onNavigate={onNavigate}
            onDeleteDataLink={onDeleteDataLink}
        >
            <WidgetPlainText text={data.text} style={widgetService.getWidgetContentStyle(widget)} />
        </WidgetFrame>
    )
}
